import { render } from "./ViewEmbedPostModal.vue?vue&type=template&id=275bb9ae&ts=true"
import script from "./ViewEmbedPostModal.vue?vue&type=script&lang=ts"
export * from "./ViewEmbedPostModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__